import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next';
import {assetExpirationEnabled} from './assetExpirationEnabled';

export const canManageExpiration = (): boolean => {
	if (!assetExpirationEnabled()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.MANAGER)) return false;
	return currentUserHasAccess(PermissionName.EXPIRE);
};
